let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dxftE")).then(() => parcelRequire('1I6Li'));